import { render } from "./PanelComandas.vue?vue&type=template&id=7ed9782e&scoped=true"
import script from "./PanelComandas.vue?vue&type=script&lang=js"
export * from "./PanelComandas.vue?vue&type=script&lang=js"

import "./PanelComandas.vue?vue&type=style&index=0&id=7ed9782e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ed9782e"]])

export default __exports__